import { render, staticRenderFns } from "./I2FormInput.vue?vue&type=template&id=3c155b8b&scoped=true"
import script from "./I2FormInput.vue?vue&type=script&lang=js"
export * from "./I2FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c155b8b",
  null
  
)

export default component.exports